module.exports = __webpack_public_path__ + "static/media/laptop_parrot.c5da2bb2.gif";